'use client';

import { FC } from 'react';
import { IconFilter } from 'src/general/Icons/IconFilter';
import { Button } from 'src/general/components/Button/Button';
import { plpFilterModalStore } from 'src/stores/plpFilterModalStore';
import { shallow } from 'zustand/shallow';

interface Props {}

/**
 * Trigger for the filters modal on PLP
 */
export const PlpFiltersTrigger: FC<Props> = () => {
  const { setOpen } = plpFilterModalStore(
    (state) => ({
      setOpen: state.setOpen,
    }),
    shallow,
  );

  return (
    <Button
      variant="secondary"
      size="small"
      onClick={() => setOpen(true)}
      endIcon={<IconFilter />}
      data-testid={`MobileSearch-component-filterButton`}
    >
      Filters
    </Button>
  );
};
